import React, { useContext } from 'react';
import cx from 'classnames';

import { FormattedMessage } from 'react-intl';

import { XingFrameContext } from '@xingternal/xing-frame-provider';
import { BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { IconInfo } from '@xingternal/icons';

import styles from './ExternalEditInfoBanner.css';

type ExternalEditInfoBannerProps = {
  copyKey: string;
  ctaCopyKey?: string;
  ctaUrl?: string;
  cyTestId?: string;
  ctaAvailableInMobile?: boolean;
};

const ExternalEditInfoBanner = ({
  copyKey,
  ctaCopyKey,
  ctaUrl,
  cyTestId,
  ctaAvailableInMobile = true,
}: ExternalEditInfoBannerProps) => {
  const { featureSwitches } = useContext(XingFrameContext);
  const canEditMobile = featureSwitches?.includes('ep_mobileEdit');

  return (
    <div
      className={cx(styles.banner, { [styles.canEditMobile]: canEditMobile })}
      data-cy={cyTestId}
    >
      <div className={styles.textContent}>
        <div className={styles.iconContainer}>
          <IconInfo width={24} height={24} />
        </div>
        <BodyCopy size={'small'} className={styles.text}>
          <FormattedMessage id={copyKey} defaultMessage={copyKey} />
        </BodyCopy>
      </div>
      {ctaCopyKey && ctaUrl && (
        <Button
          variant={'secondary'}
          size={'small'}
          className={cx(styles.bannerButton, {
            [styles.ctaAvailableInMobile]: ctaAvailableInMobile,
          })}
          href={ctaUrl}
          target={'_blank'}
          data-cy={`${cyTestId}_CTA`}
        >
          <FormattedMessage id={ctaCopyKey} defaultMessage={ctaCopyKey} />
        </Button>
      )}
    </div>
  );
};

export default ExternalEditInfoBanner;
